import type { DomainOrder } from '@shared/gql/document-nodes'
import type { FC } from 'react'

import {
  SDS_FONT_SIZE_HEADING_MEDIUM,
  SDS_FONT_WEIGHT_REGULAR,
} from '@s-group/design-system-tokens/web/tokens/font.es6'
import { SDS_SPACE_LARGE } from '@s-group/design-system-tokens/web/tokens/space.es6'
import { getCartItemsTotal } from 'domain/get-cart-items-total'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { filterPurchaseableCartItems } from 'utils/cart/filter-missing-items'

import { toSummaryLineItem } from './SmallOrderSummary'
import { SumChangeInfo } from './SumChangeInfo'

interface OrderPriceSummaryProps {
  order: DomainOrder | null | undefined
  className?: string
}

const _OrderPriceSummary: FC<OrderPriceSummaryProps> = ({ order, className }) => {
  const { t } = useTranslation()
  const cartItems = order?.cartItems ?? []

  const cartProducts = filterPurchaseableCartItems(cartItems).map(toSummaryLineItem)
  const itemsTotal = getCartItemsTotal(cartProducts)

  return (
    <div className={className} data-test-id="checkout-order-summary">
      <h2>
        {t('Shoppings')} <SumChangeInfo />
      </h2>
      <div className="price">{itemsTotal.format()}</div>
    </div>
  )
}

export const OrderPriceSummary = styled(_OrderPriceSummary)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: SDS_SPACE_LARGE,
  h2: {
    fontSize: SDS_FONT_SIZE_HEADING_MEDIUM,
    fontWeight: SDS_FONT_WEIGHT_REGULAR,
  },
  '.price': {
    fontSize: SDS_FONT_SIZE_HEADING_MEDIUM,
    fontWeight: SDS_FONT_WEIGHT_REGULAR,
    whiteSpace: 'nowrap',
  },
})
